module.exports = __webpack_public_path__ + "static/desjardin-logo-ed40be32d3fa6313eaf8622b73fa1596.png";